import TableContainer from './TableComponent';

export default TableContainer;
